<template>
  <div>
    <div class="logo-wrap">
      <img src="/assets/images/example1.png" alt="Logo" class="logo">
    </div>
    <span class="card-subheader">Vandring</span>
    <h3 class="event-name">Namn på event</h3>
    <h4 class="event-subheader">Huddinge</h4>
    <p class="price">50 kr</p>
    <p class="date">23 Nov 2024</p>
    <memlist-button @click="goto_event" variant="primary">Boka nu</memlist-button>
  </div>
</template>

<script>
import messageParent from '@/core/services/messageParent';
import axios from 'axios';
import dayjs, { Dayjs } from 'dayjs';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import i18nService from "@/core/services/i18n.service.js";

export default {
  name: 'NewPublicEventListItem',
  components: {
    
  },
  props: ['item'],
  mixins: [ toasts ],
  computed: {
    ...mapGetters(['currentMember'])
  },
  async mounted() {
  
  },
  data() {
    return {
      local_item: {}
    };
  },
  watch: {
  
  },
  methods: {
    goto_event() {
      this.$router.push(`/public-event-details/${this.item.event_id}`);
    }
    
  }
};
</script>
<style scoped>

.logo-wrap {
  border-radius: 12px;
  overflow: hidden;
}

.logo {
  width: 100%;
  height: 180px;
  object-fit: cover;
  display: block;
}


.card-subheader,
.event-name,
.event-subheader,
.price,
.date,
memlist-button {
  padding: 0 0rem;
}

.card-subheader {
  margin-top: 1rem;
  font-size: 0.75rem;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: #b85504;
}

.event-name {
  margin: .25rem 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #212529;
}

.event-subheader {
  margin: 0 0 .75rem;
  font-size: 1rem;
  font-weight: 400;
  color: #495057;
}

.price {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f8a70;
  margin: 0 0 .25rem;
}

.date {
  font-size: .875rem;
  color: #6c757d;
  margin: 0 0 1rem;
}

memlist-button {
  display: block;
  width: calc(100% - 2.5rem);
  margin: 0 1.25rem 1.25rem;
  text-align: center;
}

</style>